import React from 'react';
import Base64ToSvg from '#web-components/components/Base64ToSvg';
import SvgUrlImage from '#web-components/components/SvgUrlImage';

export default function LogoImage() {
  if (FTL_PARAMS?.logoHeader) {
    return <Base64ToSvg logoBase64={FTL_PARAMS.logoHeader} />;
  }
  return (
    <SvgUrlImage url={`${FTL_PARAMS.resourcesPath}/logos/header-logo.svg`} />
  );
}
